import React from 'react';

/**
 * ExternalLink component that automatically adds security attributes
 * to prevent reverse tabnabbing attacks.
 *
 * Always use this component for external links instead of raw <a> tags
 * with target="_blank".
 *
 * @param {string} href - The URL to link to
 * @param {React.ReactNode} children - The link content
 * @param {string} className - Optional CSS classes
 * @param {object} props - Additional props passed to the <a> element
 */
const ExternalLink = ({ href, children, className, ...props }) => {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className={className} {...props}>
      {children}
    </a>
  );
};

export default ExternalLink;
